// src/api/mvzAdminApi.ts
import client from "./client";
import { ApiResponse, PageResponse } from "../types";

export interface MvzAdminListItem {
  id: string;
  nombre: string;
  numeroMatricula: string;
  fotoUrl?: string;
  documentoGraduacionUrl?: string;
  verificado: boolean;
  activo: boolean;
  experienciaAnios?: number;
  descripcion?: string;
  usuarioEmail?: string;
  usuarioNombre?: string;
  ciudadNombre?: string;
  departamentoNombre?: string;
  createdDate?: string;
}

export interface MvzAdminDetail {
  id: string;
  usuarioId: string;
  nombre: string;
  numeroMatricula: string;
  descripcion?: string;
  fotoUrl?: string;
  documentoGraduacionUrl?: string;
  motivoRechazoVerificacion?: string;
  experienciaAnios?: number;
  disponibilidad: string;
  calificacionPromedio: number;
  totalReviews: number;
  verificado: boolean;
  activo: boolean;
  ciudadNombre?: string;
  departamentoNombre?: string;
  tiposAnimales?: { id: string; nombre: string }[];
  servicios?: { id: string; servicioNombre: string; precio?: number }[];
}

export interface VerificarMvzPayload {
  aprobado: boolean;
  motivo?: string;
}

export const mvzAdminApi = {
  listar: (page = 0, size = 20, soloSinVerificar = false) =>
    client.get<ApiResponse<PageResponse<MvzAdminListItem>>>(
      "/api/v1/admin/mvz",
      {
        params: { page, size, soloSinVerificar },
      },
    ),

  detalle: (mvzId: string) =>
    client.get<ApiResponse<MvzAdminDetail>>(`/api/v1/admin/mvz/${mvzId}`),

  verificar: (mvzId: string, payload: VerificarMvzPayload) =>
    client.post<ApiResponse<MvzAdminDetail>>(
      `/api/v1/admin/mvz/${mvzId}/verificar`,
      payload,
    ),
};
